let globalApiToken = '';

export const getGlobalApiToken = (): string => globalApiToken;

export const setGlobalApiToken = (token: string): void => {
  globalApiToken = token || '';
};

export const clearGlobalApiToken = (): void => {
  globalApiToken = '';
};

export const appendApiTokenHeader = (headers: Headers): void => {
  if (headers.has('Authorization')) {
    return;
  }

  const token = getGlobalApiToken();
  if (token) {
    headers.append('Authorization', `Bearer ${token}`);
  }
};
